import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiRouter } from '../../../../global/routes/api-routes';
import { map } from 'rxjs';
import { Option } from '../../../../shared/interfaces/lookup-options.interfaces';

type BVValueLookupResponse = {
  category: string;
  label: string;
  make: string;
  value: string;
};
@Injectable({
  providedIn: 'root',
})
export class BeValuedLookupService {
  constructor(private readonly http: HttpClient) {}

  lookupOptionsForStep(queryConfig: { group: string; manufacturer: string }, modelNumber: string) {
    return this.http
      .post<BVValueLookupResponse[]>(ApiRouter.orbit.bvModelNumberLookup(), {
        ...queryConfig,
        modelNumber,
      })
      .pipe(
        map((val) => {
          return val.map((item) => {
            return {
              title: item.label,
              dataLabel: item.label,
              value: {
                ...item,
                dataLabel: item.label,
              },
            } as unknown as Option;
          });
        })
      );
  }
}
